import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ClassificationDetail } from '../../../models/classification.model';
import { ClassificationService } from '../../../services/classification/classification.service';

@Component({
  selector: 'app-common-classification-details-form',
  templateUrl: './classification-details-form.component.html',
  styles: ['label.required:after {top: 0}']
})

export class ClassificationDetailsFormComponent implements OnInit {

  @Output() onAddElement: EventEmitter<any> = new EventEmitter<any>();
  @Input() editingElement: ClassificationDetail;

  addEditFormDetails: FormGroup;
  fields: any;
  public invalidSubmit: boolean;

  constructor(
    private fb: FormBuilder,
    private svcClassification: ClassificationService) {
  }

  ngOnInit(): void {

    this.svcClassification.getFieldsDetail().subscribe(res => {
      this.fields = res;
    });

    this.addEditFormDetails = this.fb.group({
      'code': new FormControl(this.editingElement.code),
      'description': new FormControl(this.editingElement.description),
    });

  }

  saveOrUpdate(): void {

    if (!this.addEditFormDetails.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.editingElement, this.addEditFormDetails.value);
    this.onAddElement.emit(newData);

  }

}



// WEBPACK FOOTER //
// ./src/app/views/classification/classification-details/classification-details-form.component.ts